import { useEffect } from 'react';

import { getTaxResidence } from '../store/taxResidence.actions';

import { IUser } from '@/features/user/store/user.model';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';
import { selectTaxResidencesByUserId } from '@/store/selectors';
import { TaxResidencesDetails } from '@/features/taxResidences/components/TaxResidencesDetails';
import { TaxResidencesEdition } from '@/features/taxResidences/components/TaxResidencesEdition';

interface ITaxResidence {
  user: IUser;
  isSectionOnEdition: boolean;
  isSectionEditable: boolean;
  toogleSectionEditMode: () => void;
}

export function TaxResidences({ user, isSectionOnEdition, isSectionEditable, toogleSectionEditMode }: ITaxResidence) {
  const dispatch = useAppDispatch();

  const taxResidences = useAppSelector((state) => selectTaxResidencesByUserId(state, user?.userId));

  useEffect(() => {
    if (taxResidences === undefined) {
      dispatch(getTaxResidence(user.userId));
    }
  }, [dispatch, taxResidences, user.userId]);

  return isSectionOnEdition ? (
    <TaxResidencesEdition
      user={user}
      isSectionEditable={isSectionEditable}
      toogleSectionEditMode={toogleSectionEditMode}
    />
  ) : (
    <TaxResidencesDetails
      user={user}
      isSectionEditable={isSectionEditable}
      toogleSectionEditMode={toogleSectionEditMode}
    />
  );
}
